module.exports = __webpack_public_path__ + "img/392.04f43596.jpg";